import Polyglot from "node-polyglot"

let enMessages = {
    "tomorrow_night": "Tomorrow",
    "one": "1",
    "top_location": "Featured Destinations",
    "select_destination" : "Select Destination",
    "select_facilities": "Select Facilities",
    "location" : "Where to go?",
    "locations" : "Where to go?",
    "facilities": "Which facilities?",
    "number_of_room": "Number Of Room(s)",
    "room" : "Room",
    "rooms" : "Rooms",
    "search" : "Search Hotel",
    "local" : "Local",
    "local_guests": "Local Guest(s)",
    "foreigner" : "Foreigner",
    "foreigner_guests" : "Foreigner Guest(s)",
    "checkin_date" : "Check-in",
    "checkout_date" : "Check-out",
    "all_photos" : "Photos",
    "photo" : "Photo",
    "photos" : "Photos",
    "townships" : "Townships",
    "prices" : "prices",
    "all_prices" : "all prices",
    "lowest_prices" : "Lowest to Highest",
    "highest_prices" : "Highest to Lowest",
    "price_range" : "Price Range",
    "sorting_price": "Sorting Price",
    "promotion" : "promotion",
    "select_township" : "Select TownShip",
    "select_price_range" : "Select Price Range",
    "select_price_order_type" : "Select Price Order Type",
    "from" : "Starting From ( 1 room / night )",
    "check_out" : "Check Out",
    "read_more" : "Read More",
    "read_less" : "Read Less",
    "details" : "View Daily Price Details",
    "select" : "Select",
    "room_detail" : "Room Details",
    "view_booking_details" : "View Booking Details",
    "name" : "Primary Guest Name",
    "gender" : "Gender",
    "male" : "Male",
    "female" : "Female",
    "gender_male" : "Male",
    "gender_female" : "Female",
    "gender_undisclosed" : "Undisclosed",
    "email" : "Email (for booking confirmation)",
    "phone_number" : "Phone Number (for booking confirmation)",
    "nationality" : "Nationality",
    "myanmar" : "Myanmar",
    "special_request" : "Special Request",
    "special_request_hint" : "Eg : low-floor room",
    "submit" : "Submit",
    "contect_header" : "Enter Your Information",
    "room_label" : "Rooms",
    "small_letter_room" : "room",
    "small_letter_rooms" : "rooms",
    "small_letter_night" : "night",
    "small_letter_nights" : "nights",
    "night" : "Night",
    "nights" : "Nights",
    "cancellation_policy" : "Cancellation Policy",
    "extra_bed" : "Extra Bed",
    "add_extra_bed" : "Add Extra Bed",
    "no_included" : "No Included",
    "included" : "Included",
    "secure_checkout" : "Secure CheckOut",
    "non_refundable" : "Non Refundable",
    "sub_total" : "SubTotal",
    "convience_fee" : "Convience Fee",
    "total" : "Total",
    "pay_now" : "Pay Now",
    "payment_summary" : "Payment Summary",
    "payment": "Payment",
    "contact_information" : "Contact Information",
    "edit" : "Edit",
    "delete": "Delete",
    "gallery" : "Gallery",
    "warning_cancel_guest_state": "Are you sure to cancel the selected rooms?",
    "warning_cancel_payment_state": "Are you sure to cancel all your selected information?",
    "warning_check_out_header": "Please Click Check Out Button!",
    "warning_check_out_body": "You already selected the number of rooms you defined.",
    "popup_check_out_body": "You already selected the number of rooms you defined. Please click the 'Check Out' button to fill guest information.",
    "required_rooms_already_selected": "You have already selected the required rooms!",
    "proceed_to_next_step_or_remove_selection": "Please proceed to the next step (Guest Info). Or remove the selected room.",
    "cancel_information": "Are you sure to cancel all you have been selected informations?",
    "delete_room": " - Are you sure to delete this room?",
    "no_hotels_try_other_dates": "No hotel available for the selected options. Please change your search information and try again.",
    "no_rooms_try_other_dates": "No room available on the selected date. Please try searching for other dates.",
    "cancel_all_selected": "Cancel all selected",
    "map": "Map",
    "more": "More Detail",
    "full_message": "More Detail",
    "to_selected_room": "Room(s) to be selected",
    "room_selected": "Room(s) selected",
    "room_selected_left": "Room(s) required to be selected",
    "adults": "Adults",
    "childs_old_policy": "years of age",
    "number_of_adults": "%{count} Adult(s)",
    "number_of_child": "%{count} Child",
    "number_of_guest": "Number of guests",
    "above_years_of_age": "Under %{years} years",   
    "lang_my": "MY" ,
    "for_nights": "For %{nights} night(s)",
    "description": "Description",
    "special_offer": "Value Added Promotion",
    "nearby": "Near By",
    "terms_and_conditions": "Terms And Conditions",
    "auto_fill_guest_info_title": "Auto Fill With Recent Guest Information",
    "reuse": "Reuse",
    "create_new_guest_info": "Other Guest Information",
    "create_new": "Fill New",
    "general_policy": "General Policy",
    "close": "Close",
    "guest_details": "Guest Details",
    "apply_dates": "Apply Dates",
    "choose_date": "Choose Date",
    "selected_rooms": "Selected Rooms",
    "guest_information_level": "Guest Information Level",
    "room_left": "room left",
    "rooms_left": "rooms left",
    "room_types": "Room Types",
    "save_guest_info": "Do you want to save your guest information?",
    "if_need_help": "Need Help?",
    "frequently_asked_questions": "Frequently Asked Questions",
    "hotel_location": "Location Map",
    "near_location": "Near %{location_name}",
    "miles_from_location": "%{location_name} - %{miles} miles",
    "room_rates_only_for_local": "Selected room(s) and rate(s) only eligible for local guests.",
    "room_rates_only_for_foreigner": "Selected room(s) and rate(s) only eligible for foreigner guests.",
    "no_room_left": "No room left.",
    "number_room_left": "%{count} room left",
    "number_rooms_left": "%{count} rooms left",
    "discount_applied": "discount applied",
    "extra_bed_included": "extra bed included",
    "discount_applied_and_extra_bed_included": "discount applied and extra bed included",
    "select_your_rooms": "Select Your Rooms",
    "search_room": "Search Rooms",
    "update_search": "Update Search",
    "search_to_select": "Search with dates, number of rooms and guest type to select rooms.",
    "can_add_extra_bed": "You can add extra bed.",
    "select_num_room": "Please select %{count} room.",
    "select_num_rooms": "Please select %{count} rooms.",
    "select_num_more_room": "Select %{count} more room.",
    "select_num_more_rooms": "Select %{count} more rooms.",
    "go_to_fill_guest_info": "Proceed To Guest Info",
    "see_all": "See All",
    "clear_price_range" : "Clear Price Range",
    "restart_for_foreigner": "Restart booking for foreigner" ,
    "up_to_years_of_age": "Maximum 1 Child under the age of %{years} years can stay for free per room." ,  
    "required_dates": "Please select dates.",
    "required_guest_type": "Please choose guest type.",
    "required_destination": "Please enter a destination.",
    "total_adults": "Total Adults",
    "total_children": "Total Children",
    "email_or_phone": "Email Or Phone",
    "booking_search": "Search",
    "required_email_or_phone": "Required Email Or Phone",
    "no_booking_related_message": "There is no booking corresponding to the provided information.",
    "room_amenity": "Room Amenity",
    "find_your_booking": "Find Your Booking",
    "find_your_booking_description": "Find your booking here by providing some info about your booking. All fields in the form below are required to look up your booking",
    "booking_reference": "Booking Ref",
    "view_details": "View Details",
    "terms" : "Terms and Conditions",
    "agree_to_terms": "By continuing, you agree to the terms and conditions.",
    "proceed_to_full_payment" : "Proceed To Full Payment",
    "show_other_methods" : "Show Other Payment Methods",
    "promo_code": "Promo Code",
    "apply_code": "Apply",
    "remove_code": "Remove",
    "summary" : "Summary",
    "subtotal" : "Subtotal",
    "fees" : "Convenience Fees",
    "room_charges_and_extra_bed": "Room Charges And Extra Bed",
    "room_charges": "Room Charges",
    "extra_bad_charges": "Extra Bed Charges",
    "tax": "Tax",
    "discount": "Discount",
    "promo_discount": "Promo Discount",
    "final_amount": "Final Amount",
    "guest_info": "Guest Information",
    "guest_name": "Name",
    "guest_phone_number": "Phone Number",
    "view_more_information": "View More Information",
    "search_rooms": "Search Rooms",
    "booking_confirmed": "Your booking is confirmed.",
    "booking_cancelled": "Your booking is cancelled.",
    "booking_summary": "Booking Summary",
    "checkin_time": "Check-in Time",
    "checkout_time": "Check-out Time",
    "checkin_info": "Check-in Information",
    "regulation": "Regulation",
    "help_label": "If you need help, you can contact",
    "no_bookings": "No bookings purchased yet.",
    "my_bookings": "My Bookings",
    "full_pay_rules": "Full Payment Rules",
    "pay_full_to_hold_rooms": "Pay the bill to hold your selected rooms.",
    "pay_100_back_when_room_not_available": "If the room is not available, payment will be refunded.",
    "20_pay_rules": "20% Payment Rules",
    "pay_deposit_to_hold_rooms": "Pay %{percentage}% of the charge as a deposit to hold your selected rooms.",
    "contact_back": "We will contact you in next %{response_time}.",
    "pay_remaining_when_room_available": "The remaining %{percentage}% needs to be paid only after we confirm the room availability.",
    "pay_back_when_room_not_available": "If the room is not available, %{percentage}% of the deposit will be returned.",
    "booking_confirm": "Booking confirmation will be sent via SMS / Email.",
    "or": "( OR )",
    "proceed_to_partial_payment": "Proceed To Partial Payment ( 20% )",
    "choose_payment_pattern": "Choose a payment percentage",
    "pay": "Pay",
    "down_payment_message" : "Only %{down_payment_amount} down payment is required.",
    "must_pay_message": "%{down_payment_amount} must be paid.",
    "hotel_factilities": "Factilities",
    "payment_successful": "payment successful.",
    "contact_time_message": "within %{contact_time} to confirm the booking.",
    "contact_to_you_message": "We will contact your phone number ",
    "deposit_amount": "Deposit Amount",
    "balance_due": "Balance Due",
    "make_booking_confirmation": "Please wait for booking confirmation status.",
    "no_term_and_condition": "Terms and conditions are not defined.",
    "child_policy": "Child Policy",
    "about_hotel": "About Hotel",
    "address": "Address",
    "stay": "Allowed Stay",
    "book_now": "Book Now",
    "no_faq": "Frequently Asked Questions are not defined.",
    "privacy_policy": "Privacy Policy",
    "no_privacy_policy": "Privacy Policy are not defined.",
    "total_room_left": "Only %{total_rooms} room(s) left for the selected dates.",
    "change_number_of_room": "Reset the number of rooms.",
    "no_room_left_for_selected_dates": "No room left for the selected dates.",
    "change_selected_dates": "Reconsider Check-in - Check-out dates.",
    "warning_go_to_home_page": "Are you sure  to go back to the home page?",
    "go_to_home_page": "Go To Home Page",
    "country_of_origin": "Country of Origin",
    "require_myanmar_ph_number": "Myanmar mobile number is required. Example : 09123456789",
    "require_correct_email_format": "The correct email format is required. Example : example@gmail.com",
    "warning_payment_failed": "Payment failed. Do you want to try again?",
    "no_internet": "Internet access is required for payment. Do you want to try again?",
    "awaiting": "Awaiting...",
    "review_to_pay": "Review To Pay",
    "payment_confirmation": "Payment Confirmation",
    "generating_payment_confirmation": "Generating Payment Confirmation ...",
    "wait_for_receipt": "Please wait for the receipt.",
    "click_button_to_refresh_page": "Click the button below if taking too long.",
    "refersh_page": "Get Receipt",
    "booking_details": "Booking Details",
    "warning_delete_recent_guest_info": "Are you sure to delete %{guest_info}.",
    "warning_no_match_location": "No matching location found.",
    "warning_change_search_criteria": "Would you like to confirm new search information?",
    "hotel_discount_deals": "Special Promotions In %{town}",
    "warning_no_hotel_in_selection_location": "​is unavailable for your dates. Please consider other hotels or change your dates.",
    "select_amenity": "Select Amenity",
    "no_hotels_on_filter_amenities": "No hotel available for the selected options. Please change your search information and try again.",
    "advertise_text": "Verify your phone number to get points and enjoy rewards.",
    "points": "Points",
    "congratulations": "Congratulation!!",
    "earn_point_description": "You have earned %{point} points from booking.",
    "reward_program": "Reward Program",
    "phone_number_only": "Phone Number",
    "get_otp": "Get OTP",
    "enter_otp": "Enter OTP",
    "resend": "Resend",
    "verify": "Verify",
    "warning_enter_phone_number_first": "Please enter phone number first!",
    "warning_enter_otp": "Please enter phone number and otp first!",
    "verified_phone_number_success": "Successfully Verified!",
    "welcome_gift_message": "Here's a welcome gift from us",
    "send_otp_to_phone_number": "Otp has been sent to your phone number.",
    "my_account": "My Account",
    "point_history": "Point History",
    "special_promotion": "Special Promotions"
};

let myMessages = {
    "tomorrow_night": "မနက်ဖြန်ည",
    "one": "၁",
    "top_location": "လူသွားအများဆုံးနေရာများ",
    "select_destination" : "တည်နေရာကိုရွေးချယ်ပါ",
    "select_facilities": "ဝန်ဆောင်မှုများကို ရွေးချယ်ပါ",
    "number_of_room": "အခန်းအရေအတွက်",
    "location" : "သွားမည့် မြို့ / နေရာ",
    "locations" : "သွားမည့် မြို့ / နေရာ",
    "facilities": "ဝန်ဆောင်မှုများ",
    "room" : "ခန်း",
    "rooms" : "ခန်း",
    "search" : "ဟိုတယ်ရှာရန်",
    "local" : "မြန်မာနိုင်ငံသား",
    "foreigner" : "နိုင်ငံခြားသား",
    "local_guests" : "မြန်မာနိုင်ငံသား",
    "foreigner_guests" : "နိုင်ငံခြားသား",
    "checkin_date" : "စတည်းမည့်ရက်",
    "checkout_date" : "ပြန်မည့်ရက်",
    "all_photos" : "ပုံများ",
    "photo" : "ပုံ",
    "photos" : "ပုံ",
    "townships" : "မြို့နယ်",
    "prices" : "ဈေးနှုန်း",
    "all_prices" : "ဈေးနှုန်းအားလုံးကြည့်ရန်",
    "lowest_prices" : "အနိမ့်ဆုံးဈေး",
    "highest_prices" : "အမြင့်ဆုံးဈေး",
    "price_range" : "ဈေးနှုန်းကန့်သတ်ချက်",
    "sorting_price": "ဈေးနှုန်းစီရန်",
    "promotion" : "လျှော့ဈေး",
    "select_township" : "မြို့နယ်ကို ရွေးချယ်ပါ",
    "select_price_range" : "ဈေးနှုန်းကန့်သတ်ချက်ကို ရွေးချယ်ပါ",
    "select_price_order_type" : "ဈေးနှုန်းစီရန် ရွေးချယ်ပါ",
    "from" : "အနည်းဆုံးစျေး (တစ်ခန်း / တစ်ည)",
    "check_out" : "နောက်တစ်ဆင့်သို့",
    "read_more" : "ဆက်ဖတ်ရန်",
    "read_less" : "ပြန်ချုံ့ရန်",
    "details" : "ရက်အလိုက် စျေးနှုန်းကြည့်ရန်",
    "select" : "ရွေးမည်",
    "room_detail" : "အခန်းအသေးစိတ်",
    "view_booking_details" : "ဝယ်ယူထားသောအခန်းများအသေးစိတ်ကြည့်ရန်",
    "name" : "ဧည့်သည် အမည် ( တာဝန်ခံ ဧည့်သည် )",
    "gender" : "အမျိုးသား/အမျိုးသမီး",
    "male" : "အမျိုးသား",
    "female" : "အမျိုးသမီး",
    "gender_male" : "အမျိုးသား",
    "gender_female" :"အမျိုးသမီး",
    "gender_undisclosed" : "မပြောနိုင်",
    "email" : "အီးမေးလ် ( ဘိုကင်အတည်ပြုမှု ရယူရန် )",
    "phone_number" : "ဖုန်းနံပါတ် ( ဘိုကင်အတည်ပြုမှု ရယူရန် )",
    "nationality" : "နိုင်ငံသား",
    "myanmar" : "မြန်မာနိုင်ငံသား",
    "special_request" : "ဟိုတယ်သို့ တောင်းဆိုချက်",
    "special_request_hint" : "ဥပမာ - အထပ်နိမ့်အခန်း ပေးပါ",
    "submit" : "နောက်တစ်ဆင့်သို့",
    "contect_header" : "ဧည့်သည်အချက်အလက် ဖြည့်ရန်",
    "room_label" : "အခန်း",
    "small_letter_room" : "ခန်း",
    "small_letter_rooms" : "ခန်း",
    "small_letter_night" : "ည",
    "small_letter_nights" : "ည",
    "night" : "ည",
    "nights" : "ည",
    "cancellation_policy" : "ပယ်ဖျက်ခြင်းမူဝါဒ",
    "extra_bed" : "ကုတင်အပို",
    "add_extra_bed" : "ကုတင်အပိုထည့်ရန်",
    "no_included" : "မပါ",
    "included" : "လုံး",
    "secure_checkout" : "ဧည့်သည်အချက်အလက် အဆင့်",
    "non_refundable" : "ငွေပြန်မအမ်းပါ",
    "sub_total" : "အခန်းအတွက် ကျသင့်ငွေ",
    "convience_fee" : "ငွေပေးချေစနစ် ဝန်ဆောင်ခ",
    "total" : "စုစုပေါင်းကျသင့်ငွေ",
    "pay_now" : "ငွေပေးမည်",
    "payment_summary" : "ငွေပေးချေမှု အကျဉ်းချုပ်",
    "payment": "ငွေပေးချေမှု အဆင့်",
    "contact_information" : "ဧည့်သည်အချက်အလက်",
    "edit" : "ပြင်ရန်",
    "delete": "ဖျက်မည်",
    "gallery" : "ဓာတ်ပုံများ",
    "warning_cancel_guest_state": "သင်ရွေးချယ်ထားသော အခန်းများ ပျက်ပြယ်သွားမည်။ အနောက်ပြန်သွားရန် သေချာပါသလား ?",
    "warning_cancel_payment_state": "သင်ရွေးချယ်ထားသော အချက်လက်အားလုံး ပျက်ပြယ်သွားမည်။ အနောက်ပြန်သွားရန် သေချာပါသလား ?",
    "warning_check_out_header": "ကျေးဇူးပြုပြီး နောက်တစ်ဆင့်သို့ သွားရန်နှိပ်ပါ",
    "warning_check_out_body": "သင်သတ်မှတ်ထားသော အခန်းအရေအတွက်ကို ရွေးချယ်ထားပြီးဖြစ်သည်",
    "popup_check_out_body": "သင်သတ်မှတ်ထားသော အခန်းအရေအတွက်ကို ရွေးချယ်ထားပြီးဖြစ်သည်။ ဧည့်သည်အချက်အလက်ဖြည့်ရန် နောက်တစ်ဆင့်သို့ သွားပါ။",
    "required_rooms_already_selected": "သင်သတ်မှတ်ထားသော အခန်းအရေအတွက်ကို ရွေးချယ်ထားပြီးဖြစ်သည်။",
    "proceed_to_next_step_or_remove_selection": "နောက်တစ်ဆင့်သို့သွားရန် ရွေးချယ်မှုကိုအတည်ပြုပါ။ သို့မဟုတ် ရွေးချယ်ထားသော အခန်းကို ဖယ်ရှားပါ။",
    "cancel_information": "သင်ရွေးချယ်ထားသော အချက်အလက်များအား သင်ဖျက်သိမ်းရန် သေချာပါသလား ?",
    "delete_room": " အခန်းကို ပယ်ဖျက်ရန် သေချာပါသလား?",
    "no_hotels_try_other_dates": "ရွေးချယ်ထားသည့်အချက်အလက်များနှင့် ကိုက်ညီသော ဟိုတယ်မရနိုင်ပါ။ အချက်အလက်များ ပြောင်းလဲ၍ ရှာဖွေကြည့်ပါ။",
    "no_rooms_try_other_dates": "ရွေးချယ်ထားသည့်ရက်စွဲတွင် အခန်းများမရနိုင်ပါ။ အခြားရက်စွဲများကို ရှာဖွေကြည့်ပါ။",
    "cancel_all_selected": "ရွေးချယ်မှုအားလုံးကို ပယ်ဖျက်မည်",
    "map": "မြေပုံ",
    "more": "အားလုံးကြည့်ရန်",
    "full_message": "အပြည့်အစုံ",
    "to_selected_room": "ခန်းရွေးရန်",
    "room_selected": "ခန်းရွေးပြီး",
    "room_selected_left": "ခန်းရွေးရန်ကျန်",
    "adults": "လူကြီး",
    "childs_old_policy": "နှစ်အထက်",          
    "number_of_adults": "လူကြီး %{count} ဦး",
    "number_of_child": "ကလေး %{count} ဦး",
    "discount_applied": "လျှော့စျေးပါပြီး",
    "extra_bed_included": "ကုတင်အပိုခပါပြီး",
    "discount_applied_and_extra_bed_included": "လျှော့စျေးနှင့် ကုတင်အပိုခပါပြီး",
    "number_of_guest": "လူအရေအတွက်",
    "above_years_of_age": "%{years} နှစ်အောက်",
    "for_nights": "%{nights} ညစာ",
    "lang_my": "MY" ,
    "description": "အကြောင်းအရာ",
    "special_offer": "အထူးအခွင့်ရေး",
    "nearby": "အနီး",
    "terms_and_conditions": "စည်းကမ်းချက်များ",
    "auto_fill_guest_info_title": "ဧည့်သည်အချက်အလက် အဟောင်းများ",
    "reuse": "သုံးမည်",
    "create_new_guest_info": "ဧည့်သည်အချက်အလက် အသစ်ဖြည့်ရန်",
    "create_new": "အသစ်ဖြည့်မည်",
    "general_policy": "အထွေထွေမူဝါဒ",
    "close": "ပြန်ပိတ်ရန်",
    "guest_details": "ဧည့်သည် အသေးစိတ်",
    "apply_dates": "ရက်အတည်ပြုမည်",
    "choose_date": "ရက်ရွေးချယ်ပါ",
    "selected_rooms": "ရွေးချယ်ထားသော အခန်းများ",
    "guest_information_level": "ဧည့်သည်အချက်အလက်အဆင့်",
    "room_left": "ခန်းသာကျန်",
    "rooms_left": "ခန်းသာကျန်",
    "room_types":"အခန်းအမျိုးအစားများ",
    "save_guest_info": "ဧည့်သည်အချက်အလက်ကို သိမ်းဆည်းလိုပါသလား?",
    "if_need_help": "အကူအညီလိုရင်",
    "frequently_asked_questions": "မေးလေ့ရှိသောမေးခွန်းများ",
    "hotel_location": "တည်နေရာ မြေပုံ",
    "near_location": "%{location_name} အနီး",
    "miles_from_location": "%{location_name} မှ %{miles} မိုင်အကွာ",
    "room_rates_only_for_local": "ရွေးချယ်ထားသော အခန်း(များ)နှင့် နှုန်းထား(များ)သည် မြန်မာနိုင်ငံသားများအတွက်သာ အကျုံးဝင်ပါသည်။",
    "room_rates_only_for_foreigner": "ရွေးချယ်ထားသော အခန်း(များ)နှင့် နှုန်းထား(များ)သည် နိုင်ငံခြားသားများအတွက်သာ အကျုံးဝင်ပါသည်။",
    "no_room_left":"အခန်းမကျန် တော့ပါ။",
    "number_room_left": "%{count} ခန်းသာကျန်",
    "number_rooms_left": "%{count} ခန်းသာကျန်",
    "select_your_rooms": "အခန်းကိုရွေးချယ်ပါ",
    "search_room": "အခန်းရှာမည် ",    
    "update_search": "ပြန်ရှာရန်",
    "search_to_select": "အခန်းရွေးချယ်နိုင်ရန် စတည်းမည့်ရက်၊ ပြန်မည့်ရက်၊ အခန်းအရေအတွက်နှင့် နိုင်ငံသား ရွေး၍ အခန်းရှာပါ။",
    "can_add_extra_bed": "ကုတင်အပိုထည့်နိုင်သည်",
    "select_num_room": "အခန်း %{count} ခန်း ရွေးချယ်ပါ",
    "select_num_rooms": "အခန်း %{count} ခန်း ရွေးချယ်ပါ",
    "select_num_more_room": "နောက် %{count} ခန်း ထပ်ရွေးပါ",
    "select_num_more_rooms": "နောက် %{count} ခန်း ထပ်ရွေးပါ",
    "go_to_fill_guest_info": "အခန်းရွေးချယ်မှုအတည်ပြုမည်",
    "see_all": "အားလုံးကြည့်ရန်",
    "clear_price_range" : "ဈေးနှုန်းကန့်သတ်ချက်ကို ပယ်ဖျက်မည်",
    "restart_for_foreigner": "နိုင်ငံခြားသားဧည့်သည်များအတွက် Booking ပြန်လည်စတင်ပါ။",
    "up_to_years_of_age": "အခန်း 1 ခန်းတွင် အသက် %{years} နှစ်အောက်ကလေး အများဆုံး 1 ယောက် အခမဲ့ တည်းခိုနိုင်သည်။" ,  
    "required_dates": "ရက်ရွေးပါ",
    "required_guest_type": "နိုင်ငံသားရွေးပါ",
    "required_destination": "သွားမည့်မြို့ထည့်ပါ",
    "total_adults": "လူကြီးအရေအတွက်",
    "total_children": "ကလေးအရေအတွက်",
    "email_or_phone": "အီးမေလ်း (သို့မဟုတ်) ဖုန်းနံပါတ်",
    "booking_search": "ဘိုကင်ရှာရန်",
    "required_email_or_phone": "အီးမေးလ် (သို့မဟုတ်) ဖုန်းနံပါတ် ထည့်ပါ",
    "no_booking_related_message": "ပေးထားသော အချက်အလက်များနှင့် သက်ဆိုင်သော ဘိုကင် မရှိပါ။",
    "room_amenity": "အခန်းပါဝင်ပစ္စည်း",
    "find_your_booking": "ဘိုကင်ပြန်ရှာရန်",
    "find_your_booking_description": "၀ယ်ယူခဲ့သော ဘိုကင်အချက်အလက်များကို မှန်ကန်စွာ ဖြည့်သွင်းခြင်းဖြင့် သင့်ဘိုကင်ကို ရှာဖွေနိုင်ပါသည်။",
    "booking_reference": "ဘိုကင်နံပါတ်",
    "view_details": "အသေးစိတ်ကြည့်မည်",
    "terms" : "စည်းကမ်း သတ်မှတ်ချက်များ",
    "agree_to_terms": "ငွေပေးချေမှု ဆက်လက်လုပ်ဆောင်ခြင်းဖြင့် သင်သည် စည်းကမ်း သတ်မှတ်ချက်များကို သဘောတူပြီး ဖြစ်ပါသည်။",
    "proceed_to_full_payment" :"ပေးချေမည်",
    "show_other_methods" : "အခြားငွေပေးချေမှုနည်းလမ်းများ",
    "promo_code": "ပရိုမိုကုဒ်",
    "apply_code": "ထည့်မည်",
    "remove_code": "ဖျက်မည်",
    "summary" : "Summary",
    "subtotal" : "Subtotal",
    "fees" : "Convenience Fees",
    "room_charges_and_extra_bed": "အခန်းခနှင့်ကုတင်ဖိုး",
    "room_charges": "အခန်းခ",
    "extra_bad_charges": "ကုတင်အပိုခ",
    "tax": "အခွန်ခ",
    "discount": "လျော့စျေး",
    "promo_discount": "ပရိုမို လျော့စျေး",
    "final_amount": "ပေးချေရမည့်ငွေ",
    "guest_info": "ဧည့်သည်အချက်အလက်",
    "guest_name": "ဧည့်သည်အမည်",
    "guest_phone_number": "ဖုန်းနံပါတ်",
    "view_more_information": "အချက်အလက် ထပ်ကြည့်ရန်",
    "search_rooms": "အခန်းရှာမည်",
    "booking_confirmed": "ဘိုကင် အောင်မြင်ပါသည်။",
    "booking_cancelled": "ဘိုကင် ဖြတ်သိမ်းပြီးဖြစ်သည်။",
    "booking_summary": "ဘိုကင်အကျဥ်းချုပ်",
    "checkin_time": "အခန်း၀င်ချိန်",
    "checkout_time": "အခန်းထွက်ချိန်",
    "checkin_info": "Check-in အချက်အလက်",
    "regulation": "စည်းမျဉ်းစည်းကမ်းများ",
    "help_label": "အကူအညီလိုအပ်လျှင် ဆက်သွယ်နိုင်သော ဖုန်းနံပါတ်များ",
    "no_bookings": "ဝယ်ယူထားသော ဘိုကင်များ မရှိသေးပါ။",
    "my_bookings": "ဝယ်ယူမှုမှတ်တမ်း",
    "full_pay_rules": "ငွေအပြည့်ပေးချေမှု စည်းကမ်းချက်များ",
    "pay_full_to_hold_rooms": "ကျသင့်ငွေကို ပေးချေပါ။",
    "pay_100_back_when_room_not_available": "အခန်း မရလျှင် ပြန်အမ်းငွေ ရရှိမည်။",
    "20_pay_rules": "၂၀% ငွေပေးချေမှု စည်းကမ်းချက်များ",
    "pay_deposit_to_hold_rooms": "စပေါ်ငွေအဖြစ် ကျသင့်ငွေ၏ %{percentage}% ကို ပေးချေပါ။",
    "contact_back": "အခန်း ရရှိရန် %{response_time} အတွင်း ဆောင်ရွက်ပေးပါမည်။",
    "pay_remaining_when_room_available": "ကျန် %{percentage}% ကို အခန်းရရှိကြောင်း အတည်ပြုချက်ရလျှင် ပေးချေရန် လိုအပ်ပါသည်။",
    "pay_back_when_room_not_available": "အခန်း မရလျှင် စပေါ်ငွေကို ပြန်လည်ရရှိမည်။",
    "booking_confirm": "ဘွတ်ကင်အတည်ပြုချက်ကို SMS / Email ထဲသို့ ပို့ပေးပါမည်။",
    "or": "( သို့မဟုတ် )",
    "proceed_to_partial_payment": "၂၀% ပေးမည်",
    "choose_payment_pattern": "ပေးချေမည့် ရာခိုင်နှုန်းကို ရွေးပါ",
    "pay": "ပေးမည်",
    "down_payment_message" : "%{down_payment_amount} သာ ပေးချေရန် လိုအပ်ပါသည်။",
    "must_pay_message": "%{down_payment_amount} ပေးချေရမည်။",
    "hotel_factilities": "ရရှိနိုင်သော ၀န်ဆောင်မှုများ",
    "payment_successful": "ငွေပေးချေမှု အောင်မြင်ပါသည်။",
    "contact_time_message": "${contact_time} အတွင်း",
    "contact_to_you_message": "သင်၏ဖုန်းနံပါတ် ( %{phone_number} ) သို့ ဆက်သွယ်၍ ဘိုကင်အား အတည်ပြုပေးပါမည်။",
    "deposit_amount": "စရံငွေ",
    "balance_due": "ပေးရန် ကျန်ငွေ",
    "make_booking_confirmation": "ဘိုကင် အတည်ပြုမှု လုပ်ဆောင်နေပါသည်။",
    "no_term_and_condition": "စည်းကမ်းချက်များ သတ်မှတ်ထားခြင်း မရှိသေးပါ။",
    "child_policy": "ကလေး မူဝါဒ",
    "about_hotel": "ဟိုတယ်အကြောင်း",
    "address": "တည်နေရာ",
    "stay": "ခွင့်ပြုဦးရေ",
    "book_now": "ဘိုကင် တင်မည်",
    "no_faq": "မေးလေ့ရှိသောမေးခွန်းများ မရှိသေးပါ။",
    "privacy_policy": "ကိုယ်ရေးအချက်အလက် မူဝါဒ",
    "no_privacy_policy": "ကိုယ်ရေးအချက်အလက် မူဝါဒ မရှိသေးပါ။",
    "total_room_left": "ရွေးချယ်ထားသည့်ရက်စွဲတွင် အခန်း %{total_rooms} ခန်းသာ ကျန်ပါတော့သည်။",
    "change_number_of_room": "အခန်းအရေအတွက်ကို ပြန်လည်သတ်မှတ်ပါ။",
    "no_room_left_for_selected_dates": "ရွေးချယ်ထားသည့်ရက်စွဲတွင် အခန်း မရှိတော့ပါ။",
    "change_selected_dates": "ရက်စွဲကို ပြန်လည်သတ်မှတ်ပါ။",
    "warning_go_to_home_page": "ပင်မစာမျက်နှာသို့ ပြန်သွားရန် သေချာပါသလား?",
    "go_to_home_page": "ပင်မစာမျက်နှာသို့ ပြန်သွားမည်",
    "country_of_origin": "နိုင်ငံသား",
    "require_myanmar_ph_number": "မြန်မာဖုန်းနံပါတ်သာ ထည့်ရန်။ ဥပမာ - 09123456789",
    "require_correct_email_format": "မှန်ကန်သော အီးမေးလ်ပုံစံ ထည့်ရန်။ ဥပမာ - example@gmail.com",
    "warning_payment_failed": "ငွေပေးချေမှု မအောင်မြင်ပါ။ ထပ်မံ ကြိုးစားလိုပါသလား?",
    "no_internet": "ငွေပေးချေရာတွင် အင်တာနက်ဖွင့်ထားရန် လိုအပ်ပါသည်။ ထပ်မံ ကြိုးစားလိုပါသလား?",
    "awaiting": "အတည်ပြုမှု စောင့်ဆိုင်းပါ...",
    "review_to_pay": "ကျသင့်ငွေ အချက်အလက်",
    "payment_confirmation": "ငွေပေးချေမှု ပြေစာ",
    "generating_payment_confirmation": "ငွေပေးချေမှု အတည်ပြုချက် လုပ်ဆောင်နေပါသည်။",
    "wait_for_receipt": "ကျေးဇူးပြု၍ ပြေစာအတွက် စောင့်ဆိုင်းပါ။",
    "click_button_to_refresh_page": "အချိန်ကြန့်ကြာနေပါက အောက်တွင်ပါရှိသော ခလုတ်ကို နှိပ်ပါ။",
    "refersh_page": "ပြေစာရယူမည်",
    "booking_details": "ဘိုကင်အသေးစိတ် အချက်အလက်",
    "warning_delete_recent_guest_info": "%{guest_info}ကို ဖျက်ရန် သေချာပါသလား?",
    "warning_no_match_location": "ကိုက်ညီသော မြို့/နေရာ မရှိပါ",
    "warning_change_search_criteria": "ပြောင်းလဲမှုများကို အတည်ပြုရန် သေချာပါသလား?",
    "hotel_discount_deals": "%{town}မြို့ရှိ အထူးပရိုမိုးရှင်းများ",
    "warning_no_hotel_in_selection_location": "သည် ရွေးချယ်ထားသော ရက်များတွင် မရရှိနိုင်ပါ။",
    "select_amenity": "ဝန်ဆောင်မှုများကို ရွေးချယ်ပါ",
    "no_hotels_on_filter_amenities": "ရွေးချယ်ထားသည့်အချက်အလက်များနှင့် ကိုက်ညီသော ဟိုတယ်မရနိုင်ပါ။ အချက်အလက်များ ပြောင်းလဲ၍ ရှာဖွေကြည့်ပါ။",
    "advertise_text": "ပွိုင့်စု၍ အကျိုးခံစားခွင့်များကို ရယူရန် သင့်ဖုန်းနံပါတ်ကို အတည်ပြုပါ။",
    "points": "ပွိုင့်",
    "congratulations": "ဂုဏ်ယူပါသည်!!",
    "earn_point_description": "ဘိုကင်တင်ခြင်းမှ ပွိုင့် %{point} ရရှိပါသည်။",
    "reward_program": "အကျိုးခံစားခွင့် အစီအစဥ်",
    "phone_number_only": "ဖုန်းနံပါတ်",
    "get_otp": "OTP ရယူပါ",
    "enter_otp": "OTP ထည့်ပါ",
    "resend": "ပြန်ပို့ပါ",
    "verify": "အတည်ပြုမည်",
    "warning_enter_phone_number_first": "ကျေးဇူးပြု၍ ဖုန်းနံပါတ်ကို အရင်ထည့်ပါ။",
    "warning_enter_otp": "ကျေးဇူးပြု၍ ဖုန်းနံပါတ် နှင့် OTP ကို အရင်ထည့်ပါ။",
    "verified_phone_number_success": "အတည်ပြုမှု အောင်မြင်ပါသည်။",
    "welcome_gift_message": "ဖုန်းနံပါတ် အတည်ပြုမှုအတွက် လက်ဆောင်ပွိုင့်များ လက်ခံရရှိခဲ့သည်။",
    "send_otp_to_phone_number": "OTP ကို ဖုန်းနံပါတ်ထဲတွင် ပေးပို့ပြီး ဖြစ်သည်။",
    "my_account": "ကျွန်ုပ်၏ အကောင့်",
    "point_history": "ပွိုင့်မှတ်တမ်းများ",
    "special_promotion": "အထူးပရိုမိုးရှင်းများ"
};

class MessageProvider {
    private currentLang:string;
    private polyglot:Polyglot;

    constructor(defaultLang:string) {
        this.currentLang = defaultLang;
        if(window.localStorage) {
           let storedLang = window.localStorage.getItem('lang');
           if(storedLang == "en" || storedLang == "my") {
               this.currentLang = storedLang;
               console.log("Read lang from local storage : ", storedLang);
           } 
        }  

        this.polyglot = new Polyglot();
        this.polyglot.extend({
            "en": enMessages,
            "my": myMessages
        });
    }

    setCurrentLang(lang:string) {
        this.currentLang = lang;
        if(window.localStorage) {
            window.localStorage.setItem('lang', lang);
        }        
    }

    getCurrentLang():string {
        return this.currentLang;
    }

    getByLang(key:string, lang:string):string {
        let langKey = lang + "." + key;
        return this.polyglot.t(langKey);
    }

    get(key) {
        return this.getByLang(key, this.currentLang);
    }

    interpolate(key:string, keyValues:any) {
        let langKey = this.currentLang + "." + key;
        return this.polyglot.t(langKey, keyValues);
    }
}

export default MessageProvider;